import React from "react";
import Public from "@mui/icons-material/Public";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExlySearchableDropdown from "repoV2/features/Common/modules/Form/modules/ExlySearchableDropdown/ExlySearchableDropdown";
import {
    getFormattedTimezoneOptions,
    useTimezoneSelector,
} from "./TimezoneSelector.utils";
import styles from "./TimezoneSelector.module.scss";

const { formatted_timezone_options, formatted_timezones_map } =
    getFormattedTimezoneOptions();

/**
 * TimezoneSelector is being used at multiple places, so
 * we are passing 'timezoneFieldName' from the props as field name has
 * to be unique
 */
const TimezoneSelector = (props: { timezoneFieldName: string }) => {
    const { timezoneFieldName } = props;
    const { setTimezoneData, timezoneDetails } = useTimezoneSelector();

    const value = formatted_timezones_map?.[timezoneDetails?.name || ""];

    return (
        <div className={styles.Wrapper}>
            <Public className={styles.GlobeIcon} />
            <ExlySearchableDropdown
                clearOnFocus
                name={timezoneFieldName}
                options={formatted_timezone_options}
                classes={{
                    root: styles.rootStyles,
                    textInput: styles.TextInput,
                    inputRoot: styles.selectInput,
                    listbox: styles.timezoneSelectMenu,
                    popper: styles.timezonePopper,
                    endAdornment: styles.timezoneEndAdornment,
                }}
                inputVariant="standard"
                menuPlacement="bottom-end"
                onChange={option => {
                    setTimezoneData({
                        value: option.value,
                    });
                }}
                value={value}
                ExpandIcon={
                    <ExpandMore className={styles.timezoneSelectorIconStyle} />
                }
            />
        </div>
    );
};

export default TimezoneSelector;
